import { render, staticRenderFns } from "./HsabEnrollmentSettings.vue?vue&type=template&id=3588df24&scoped=true"
import script from "./HsabEnrollmentSettings.vue?vue&type=script&lang=ts"
export * from "./HsabEnrollmentSettings.vue?vue&type=script&lang=ts"
import style0 from "./HsabEnrollmentSettings.vue?vue&type=style&index=0&id=3588df24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3588df24",
  null
  
)

export default component.exports